import '.a{display:flex;}.ssr-plugin'
import '.bd{justify-content:flex-start;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.dd{max-width:1280px;}.ssr-plugin'
import '.k{margin:0 auto;}.ssr-plugin'
import '.m{flex:1;}.ssr-plugin'
import '.dt{padding-right:0px !important;}.ssr-plugin'
import { useState } from 'react'
import { styled } from 'inlines'
import { Layout } from '../pages/Layout'
import { useTranslations } from '../hooks/useTranslations'
import { useScrollToTop } from '../hooks/useScrollToTop'
import { useIsIpad, useIsMobile } from '../hooks/useIsMobile'
import { Navigation } from './Navigation'
import { useAppCtx } from '../providers/useAppCtx'
import { Text } from './Text'
import { useTheme } from '../providers/useTheme'
import { Video } from 'excelsis-video'
import { Button } from './Button'

export const RecapVideo = ({ src, setWatchedRecap }) => {
  const [videoFinished, setVideoFinished] = useState(false)
  const [remainingTime, setRemainingTime] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const { data: dictionary = {} } = useTranslations('recap_video')
  const { languages, votesCount } = useAppCtx()

  const { colors } = useTheme()

  useScrollToTop()

  const isIpad = useIsIpad()
  const isMobile = useIsMobile()

  return (
    <Layout
      style={{
        gap: 48,
        ...(isIpad
          ? {
              padding: '32px 24px',
              justifyContent: 'start',
              alignItems: 'center',
            }
          : {
              padding: '48px 24px',
              alignSelf: 'center',
            }),
      }}
    >
      <Layout.Navbar>
        <Navigation
          as="nav"
          aria-label="Main navigation"
          // isCartVisible
          isExpandable
          cartItems={votesCount}
          languages={languages}
        />
      </Layout.Navbar>

      <Layout.Middle>
        <div className="a bd h dd k"
          style={{
            alignItems: isIpad ? 'inherit' : 'center',
            gap: isIpad ? 32 : 48,
            flexDirection: isIpad ? 'column' : 'row',
          }}
        >
          <div className="h m">
            <Video
              // @ts-ignore
              onEnded={() => {
                setVideoFinished(true)
                setIsPlaying(false)
              }}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onTimeUpdate={(e: React.SyntheticEvent<HTMLVideoElement>) => {
                const video = e.currentTarget
                const remaining = Math.ceil(video.duration - video.currentTime)
                setRemainingTime(remaining)
              }}
              autoPlay
              src={src}
              style={{
                width: '100%',
                maxWidth: isIpad ? '1024px' : '624px',
                overflow: 'hidden',
                objectFit: 'cover',
                borderRadius: '12px',
                '& img': { borderRadius: '12px' },
              }}
            >
              {!isPlaying && (
                <Video.PlayButton
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: '40px',
                    width: 76,
                    height: 76,
                    '& svg': {
                      width: '42px',
                      height: '42px',
                    },
                  }}
                />
              )}
              <Video.TimeLine
                style={{
                  position: 'absolute',
                  width: 'calc(100% - 16px)',
                  bottom: 0,
                  left: 8,
                  right: 8,
                  pointerEvents: 'none',
                }}
              />
              <Video.FullscreenButton
                style={{ position: 'absolute', right: 6, top: 6 }}
              />
            </Video>
          </div>
          <div className="dt m"
            style={{
              padding: isIpad ? 0 : 48,
              textAlign: isIpad ? 'center' : 'left',
            }}
          >
            <Text
              color={'gradient'}
              variant="title"
              isMultiline
              style={{
                marginBottom: 16,
                textAlign: isIpad ? 'center' : 'left',
              }}
            >
              {dictionary?.recap_title}
            </Text>
            <Text
              color={colors.textSecondary}
              isMultiline
              style={{
                marginBottom: 32,
                textAlign: isIpad ? 'center' : 'left',
              }}
            >
              {dictionary?.recap_instructions}
            </Text>
            <Button
              isDisabled={!videoFinished}
              on={{ click: () => setWatchedRecap(true) }}
              style={{ width: isMobile ? 'calc(100% - 1rem)' : 'auto' }}
            >
              <Text style={{ color: colors.background }}>
                {videoFinished
                  ? dictionary?.continue_to_voting_button
                  : `${dictionary?.continue_to_voting_button} ${remainingTime ? `${Math.floor(remainingTime / 60)}:${String(remainingTime % 60).padStart(2, '0')}` : ''}`}
              </Text>
            </Button>
          </div>
        </div>
      </Layout.Middle>

      <Layout.Footer>
        <Navigation
          as="footer"
          aria-label="Footer navigation"
          languages={languages}
          style={{ marginBottom: 0 }}
        />
      </Layout.Footer>
    </Layout>
  )
}
